// Display helper for dish tag values (originTags / dietaryTags /
// allergenTags). Tolerates both the legacy wire format (plain
// kebab-case value, e.g. "gluten-free") and the translated wire format
// (`"value,label"`, e.g. "gluten-free,Sin gluten").
//
// The BE emits "value,label" once the listing-translation pipeline has
// resolved a label for the current language (see
// `api-core-go/common/translation/translate.go::ApplyListingTranslation`).
// In the read paths that don't yet flow through translation (home-feed
// search today), values arrive as plain strings and we fall back to
// title-casing the kebab.
//
// Strip-on-first-comma is the parse rule — values themselves never
// contain commas (BE strips on persist).
export function displayTag(value: string): string {
  if (!value) return '';
  const commaIdx = value.indexOf(',');
  if (commaIdx >= 0) {
    const label = value.slice(commaIdx + 1).trim();
    if (label) return label;
    // Empty label after comma — defensive: fall through to title-case
    // of the value portion rather than render an empty chip.
  }
  const raw = commaIdx >= 0 ? value.slice(0, commaIdx) : value;
  return raw
    .split('-')
    .map((p) => (p.length === 0 ? p : p.charAt(0).toUpperCase() + p.slice(1)))
    .join(' ');
}

/**
 * Strip the label portion off a tag value, returning just the wire-format
 * key. Use when sending tags back to the BE (publish/update flows) — the
 * BE only persists keys, not labels.
 */
export function tagValue(value: string): string {
  if (!value) return '';
  const commaIdx = value.indexOf(',');
  return commaIdx >= 0 ? value.slice(0, commaIdx) : value;
}
